<script>

    let showInfo = false;
    export let chartConfig;
    export let text;
    export let chartType;
    export let currentPage;
    export let total;
    export let keywordTitle;

    import highcharts from "../../../utils/highcharts";
    import highchartsmap from "../../../utils/highchartsmap";


</script>


<div id="chart-container">

    <h1 class="chart-title">
        <span class="title">{@html keywordTitle ? `Übersicht (<b>${keywordTitle}</b>)` : text[currentPage][chartType]['data']['title'] }</span>
        <span class="info show"><img src="images/icon-info.svg" alt="Chart Info" on:click={() => showInfo = !showInfo}></span>
    </h1>

    <div id="nodata" class:show={total === 0}>{text['errore']}</div>

    {#if chartConfig}
        <div id="chart" data-charttype="reviews_{chartType}" use:highcharts={chartConfig}></div>
    {/if}


</div>

<div class="chart-info" data-chartid="reviews_{chartType}" class:show={showInfo}>

    <div class="close">
        <img src="images/icon-close.svg" alt="Close" on:click={() => showInfo = !showInfo}/>
    </div>

    <div class="title">{text[currentPage][chartType]['info']['title']}</div>

    <div class="notice">

        {@html text[currentPage][chartType]['info']['content']}

    </div>

</div>